import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ApiRequestService } from '../../../BaseFramework/core/http/api-request.service';
import { CommonUtilty } from '../../../BaseFramework/core/utilities/commonUtility';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class FwaDashboardService {

  constructor(private apiRequest: ApiRequestService,            
            private commonUtility: CommonUtilty,
            private http: HttpClient) { }

  masterData = '1234';

  fetchCardsData(selectedDateRange){
    let fetchCards = new Subject<any>();

    this.apiRequest.post('fetchData', selectedDateRange)
        .subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            fetchCards.next(returnObj);
        });
    return fetchCards;
  }

  fetchMonthlyWeeklyReport(){
    let fetchReport = new Subject<any>();

    this.apiRequest.get('fetchData').subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            fetchReport.next(returnObj);
        });
    return fetchReport;
  }

  fetchFWADataAgainstClaimNumber(claimNum){
    let fwaForClaim = new Subject<any>();

    this.apiRequest.post('fetchData', claimNum)
        .subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            fwaForClaim.next(returnObj);
        });
    return fwaForClaim;
  }

  fetchTriggersData(selectedTrigger){
    let fetchTriggerData = new Subject<any>();

    this.apiRequest.post('fetchData', selectedTrigger)
        .subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            fetchTriggerData.next(returnObj);
        });
    return fetchTriggerData;
  }

  fetchClaimByClaimNum(claimNum){
    let ClaimDataSubject = new Subject<any>();
    let url = 'fetchByClaimNum';
    let pathVariables = [];
    pathVariables.push(claimNum);
    this.apiRequest.getCallWithAPIMapper(url, null, null, pathVariables)
        .subscribe(jsonResp => {
            let returnObj = jsonResp;
            console.log(returnObj);
            ClaimDataSubject.next(returnObj);
        });

    return ClaimDataSubject;
  }

  fetchFraudProbability(claimData){
    let claimFraudPredictionSubject = new Subject<any>();
    const body = claimData;
    let url = 'https://product-dev-v2-fwa.metamorphosys.co.in/dev-fwa-generic/model_predict';
    const headers = { 'Content-Type': 'application/json' };

    this.http.post<any>(url, body, { headers })
        .subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            claimFraudPredictionSubject.next(returnObj);
        },err => {
          err.isError = true;
          claimFraudPredictionSubject.next(err);
      });
    return claimFraudPredictionSubject;
  }

  fetchFWAPattern(requestJSON){
    let claimFWAPatternSubject = new Subject<any>();
    const body = requestJSON;
    let url = 'https://product-fwa.metamorphosys.co.in/dev-fwa-generic/model_lime_reasons';
    const headers = { 'Content-Type': 'application/json' };

    this.http.post<any>(url, body, { headers })
        .subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            claimFWAPatternSubject.next(returnObj);
        },err => {
          err.isError = true;
          claimFWAPatternSubject.next(err);
      });
    return claimFWAPatternSubject;
  }

  generateInsightsFromRuleOutput(data){
    let translateResponse = new Subject<any>();
    const headers = { 'Content-Type': 'application/json' };
    const body = data;

    let URL = 'https://product-fwa.metamorphosys.co.in/dev-dsp-life/meta-gpt/generateInsightsFromRuleOutput'
    this.http.post<any>(URL, body, { headers })
        .subscribe(jsonResp => {
            let returnObj = this.commonUtility.deepCopy(jsonResp);
            translateResponse.next(returnObj);
        },err => {
            translateResponse.next(err);
        });
    return translateResponse;
  }

}
